
import React from 'react';

import AuthenticationService from '../../backend/AuthenticationService';
import { translate } from "react-i18next";
import { Button, Card, ListGroup, ListGroupItem } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../App.css';
import { GREEN_BG} from "../../backend/Colors";


class CreateEventWidget extends React.Component {

    render() {
        const { t } = this.props;
        let user = AuthenticationService.getLoggedUser();  //"#myevents/" + user.id
        return (
            <Card  className="ml-2 " >
                <Card.Header style={{"backgroundColor": GREEN_BG}}><i className="text-success fa fa-user s24  ml-2 mr-1 " >&nbsp;</i>{ t("myPrivateEvents") }</Card.Header>
                <Card.Body className="pt-0 pb-0">
                    <ListGroup className="list-group-flush">
                        <ListGroupItem><Link to={!user ? `/loginPage/searchActivity`:`/myevents/${user.id}`}  >Meine Ereignisse</Link></ListGroupItem>
                        <ListGroupItem><Link to={!user ? `/loginPage/searchActivity`:`/myInvitations/${user.id}`}  >Einladungen</Link></ListGroupItem>
                        <ListGroupItem><Link to={!user ? `/loginPage/searchActivity`:`/eventFavorites/${user.id}`}  >Favoriten</Link></ListGroupItem>
                        <ListGroupItem><Link to={!user ? `/loginPage/searchActivity`:`/eventSubscriptions/${user.id}`}  >Abos</Link></ListGroupItem>
                    </ListGroup>
                </Card.Body>
                <Card.Footer>
                <Link to={`/eventAdd`}  >
                                <Button variant="success" block size="sm" >
                                <i className=" fa fa-plus   mr-1 " ></i> {t("ActivityErstellen")}
                                </Button></Link>
                </Card.Footer>
            </Card>);
    }
}

export default translate("translations")(CreateEventWidget);
